export default "__VITE_ASSET__968e94bd__"